import { Tlt } from "@clairejs/react";
import { Button, Col, Divider, Form, Input, Row } from "antd";
import { useState } from "react";
import styled from "styled-components";

import { CreateSessionBody, IdentityProvider, RegisterAccountBody } from "../../../dto/http/user";

import { MutedBorderColor } from "../../../utils/style";

import AppleLoginButton from "./apple-login";
import FacebookLoginButton from "./facebook-login";
import GoogleLoginButton from "./google-login";

const Wrapper = styled.div`
    .ant-btn-icon {
        display: flex;
    }
`;

interface Props {
    progress?: boolean;
    disabled?: boolean;
    handleCredential?: (data: CreateSessionBody | RegisterAccountBody) => Promise<void>;
    submitButtonText?: string;
}
export default function CredentialForm({ submitButtonText, handleCredential, disabled, progress }: Props) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    return (
        <Wrapper>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 13,
                    flexWrap: "wrap",
                }}>
                <FacebookLoginButton
                    disabled={disabled}
                    onLogin={(err, token) => {
                        if (token) {
                            handleCredential?.({
                                provider: IdentityProvider.FACEBOOK,
                                data: [token.token],
                            });
                        }
                    }}
                />
                <GoogleLoginButton
                    disabled={disabled}
                    onLogin={(err, token) => {
                        if (token) {
                            handleCredential?.({
                                provider: IdentityProvider.GOOGLE,
                                data: [token.token],
                            });
                        }
                    }}
                />
                <AppleLoginButton
                    disabled={disabled}
                    onLogin={(err, token) => {
                        if (token) {
                            handleCredential?.({
                                provider: IdentityProvider.APPLE,
                                data: [token.token],
                            });
                        }
                    }}
                />
            </div>
            <Divider orientation="center">
                <div style={{ color: MutedBorderColor }}>
                    <Tlt template="or" />
                </div>
            </Divider>
            <div>
                <Form layout="vertical" disabled={disabled}>
                    <Form.Item label={<Tlt template="Email address" />}>
                        <Input onChange={(e) => setEmail(e.target.value)} size="large" type="email" />
                    </Form.Item>
                    <Form.Item label={<Tlt template="Password" />}>
                        <Input.Password onChange={(e) => setPassword(e.target.value)} size="large" />
                    </Form.Item>
                </Form>
            </div>
            <Row style={{ display: "flex", alignItems: "center" }}>
                <Col xs={24} md={12}>
                    <div id="recaptcha" />
                </Col>
                <Col xs={24} md={12}>
                    <Button
                        style={{ width: "100%" }}
                        disabled={!email || !password || disabled}
                        loading={progress}
                        size="large"
                        type="primary"
                        onClick={() =>
                            handleCredential?.({
                                provider: IdentityProvider.EMAIL,
                                data: [email, password],
                            })
                        }>
                        {submitButtonText}
                    </Button>
                </Col>
            </Row>
        </Wrapper>
    );
}
